__turbopack_context__.v({
  "modal": "Modal-module-sass-module__8LjMPq__modal",
  "modal__content": "Modal-module-sass-module__8LjMPq__modal__content",
  "modal__panel": "Modal-module-sass-module__8LjMPq__modal__panel",
  "modal__panel--fullscreen": "Modal-module-sass-module__8LjMPq__modal__panel--fullscreen",
  "modal__panel--wide": "Modal-module-sass-module__8LjMPq__modal__panel--wide",
  "modal__panel__scroll": "Modal-module-sass-module__8LjMPq__modal__panel__scroll",
  "modal__panel__scroll--footer": "Modal-module-sass-module__8LjMPq__modal__panel__scroll--footer",
});
